var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "switch-button-control" }, [
    _c(
      "div",
      {
        staticClass: "switch-button",
        class: { enabled: _vm.isEnabled },
        style: { "--color": _vm.color },
        on: { click: _vm.toggle }
      },
      [_c("div", { staticClass: "button" })]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "switch-button-label" }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b7fe45a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b7fe45a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/helpers/switch-button.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7b7fe45a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/helpers/switch-button.vue
// module chunks = 0